import { NavbarItems, SocialItems } from './../Data.js'
import "./../style/NavbarMobile.css";
import "./../style/Global.css";
import headerMobileLogo from "./../img/header-mobile-logo.png";
import hamburgerBtn from "./../img/hamburger-icon.png";
import hamburgerBtnClose from "./../img/hamburger-close-icon.png";
  

const NavbarMobile = () => {
  setTimeout(() => {
    let header = document.querySelector(".header");
    let hamnburgerBtn = document.querySelector(".hamburger-btn");
    let hamnburgerBtnClose = document.querySelector(".hamburger-btn-close");
    let headerLogoWrapp = document.querySelector(".header-logo-wrapp");
    let navbarMobileMain = document.querySelector(".navbar-mobile-main");

    const openHamburger = () => {
      header.classList.add("bg-green", "bg-image-none");
      headerLogoWrapp.classList.replace("header-logo-wrapp", "d-none");
      navbarMobileMain.classList.replace("d-none", "navbar-mobile-main");
      hamnburgerBtnClose.classList.replace("d-none", "d-block");
      hamnburgerBtn.classList.replace("d-block", "d-none");
    };
    const closeHamburger = () => {
      header.classList.remove("bg-green", "bg-image-none");
      headerLogoWrapp.classList.replace("d-none", "header-logo-wrapp");
      navbarMobileMain.classList.replace("navbar-mobile-main", "d-none");
      hamnburgerBtnClose.classList.replace("d-block", "d-none");
      hamnburgerBtn.classList.replace("d-none", "d-block");
    };

    hamnburgerBtn.addEventListener("click", openHamburger);
    hamnburgerBtnClose.addEventListener("click", closeHamburger);
  }, 0);

  return (
    <div className="navbar-mobile">
      <div>
      </div>
      <div className="navbar-hamburger">
        <img
          className="hamburger-btn d-block"
          src={hamburgerBtn}
          alt=""
        />
        <img
          className="hamburger-btn-close d-none"
          src={hamburgerBtnClose}
          alt=""
        />
      </div>
      <div className="navbar-mobile-main d-none">
        <img className="header-mobile-logo" src={headerMobileLogo} alt="" />

        <ul className="nav-mobile-link-wrapp">
          {NavbarItems.map((item, index) => {
            return (
              <li className="nav-mobile-item" key={index}>
                <a href={item.linkUrl} className="nav-mobile-link">{ item.linkName}</a>
              </li>
            )
          })}
        </ul>

        <ul className="navbar-mobile-social">
          {SocialItems.map((social, index) => {
            return (
              <li key={index}>
                <a href={social.linkUrl}>
                  <img className="mobile-social-icon" src={social.icon} alt="" />
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  );
};
export default NavbarMobile;
